import { AppBar, Tabs, Tab, Avatar } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useIsDesktop } from 'Hooks';
import { UniversalRequestTab1, UniversalRequestTab2 } from 'Images';
import React from 'react';

interface HeaderTabsProps {
  tabValue: number;
  handleTabChange: (event: React.ChangeEvent<{}>, newValue: number) => void;
}

export const HeaderTabs = ({ tabValue, handleTabChange }: HeaderTabsProps) => {
  const dictionary = Dictionary[DICTIONARY.UniversalRequest];
  const isDesktop = useIsDesktop();

  const tabStyle = {
    width: '260px',
    fontSize: isDesktop ? '18px' : '16px',
    minHeight: isDesktop ? '62px' : '40px',
    maxWidth: isDesktop ? '360px' : '50%',
    padding: 0,
    '&.Mui-selected': {
      fontWeight: '700',
    },
  };

  return (
    <AppBar
      position='static'
      sx={{
        display: 'flex',
        alignItems: 'center',
        backgroundColor: 'transparent',
        boxShadow: 'none',
      }}
    >
      <Tabs
        value={tabValue}
        onChange={handleTabChange}
        sx={{
          maxWidth: isDesktop ? undefined : '100%',
          alignItems: isDesktop ? 'initial' : 'flex-end',
        }}
      >
        <Tab
          sx={tabStyle}
          icon={
            <Avatar
              sx={{ height: '24px', width: '24px' }}
              src={UniversalRequestTab1}
              alt=''
            />
          }
          iconPosition='start'
          label={dictionary.tab1}
        />
        <Tab
          sx={tabStyle}
          icon={
            <Avatar
              sx={{ height: '24px', width: '24px' }}
              src={UniversalRequestTab2}
              alt=''
            />
          }
          iconPosition='start'
          label={dictionary.tab2}
        />
      </Tabs>
    </AppBar>
  );
};
